// Footer.js
import React, { useState, useEffect } from "react";
import SocialLinks from "./SocialLinks";
import { useLocation, Link } from "react-router-dom";

const Footer = () => {
	const [isMainPage, setIsMainPage] = useState(true);
	const currentYear = new Date().getFullYear();
	const url = useLocation()?.pathname;

	useEffect(() => {
		if (url && url.includes("/projects/")) {
			setIsMainPage(false);
		} else {
			setIsMainPage(true);
		}
	}, [url]);

	return (
		<footer className="footer section-bg text-left" role="contentinfo">
			<div className="footer__builder">
				<div className="container">
					<div className="row">
						{/* Left Column - Social Links */}
						<div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 align-left">
							<div className="social-links">
								<SocialLinks />
							</div>
						</div>
						{/* Center Column - Navigation Links */}
						<div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 align-center">
							<nav className="footer-nav" aria-label="Footer Navigation">
								{
									isMainPage ? (
										<ul style={{ listStyle: "none" }}>
										<li>
											<a
												href="#hero-section"
												title="Introduction of Murtaza Lightwala"
											>
												Home
											</a>
										</li>
										<li>
											<a href="#about-section" title="About Murtaza Lightwala">
												About
											</a>
										</li>
										<li>
											<a
												href="#resume-section"
												title="Resume of Murtaza Lightwala"
											>
												Resume
											</a>
										</li>
										<li>
											<a
												href="#works-section"
												title="Projects of Murtaza Lightwala"
											>
												Projects
											</a>
										</li>
									</ul>	
									) : (
										<ul style={{ listStyle: "none" }}>
										<li>
											<Link
												to="/"
												title="Introduction of Murtaza Lightwala"
											>
												Home
											</Link>
										</li>
										{/* <li>
											<Link to="/#about-section" title="About Murtaza Lightwala">
												About
											</Link>
										</li>
										<li>
											<Link
												to="/#resume-section"
												title="Resume of Murtaza Lightwala"
											>
												Resume
											</Link>
										</li>
										<li>
											<Link
												to="/#works-section"
												title="Projects of Murtaza Lightwala"
											>
												Projects
											</Link>
										</li> */}
									</ul>	
									)
								}
							</nav>
						</div>
						{/* Right Column - Contact Information */}
						<div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 align-right">
							<address className="contact-info">
								<p>
									<i
										className="fas fa-phone"
										style={{ marginRight: "1em" }}
									></i>
									<a href="tel:+919755565810">+91 9755 565 810</a>
								</p>
								<p>
									<i
										className="fas fa-envelope"
										style={{ marginRight: "1em" }}
									></i>
									<a href="mailto:lightwalamurtaza5210@gmail.com">
										lightwalamurtaza5210
									</a>
								</p>
								<p>
									<i
										className="fas fa-map-marker-alt"
										style={{ marginRight: "1em" }}
									></i>
									Indore, India
								</p>
							</address>
						</div>
					</div>
					{/* Bottom Row - Copyright */}
					<div className="row">
						<div className="col-xs-12 align-center">
							<div className="copyright-text">
								© {currentYear} <strong>Murtaza Lightwala</strong>. All Rights
								Reserved.
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
